export default "__VITE_ASSET__CzuhlMTc__"